import ButtonSelect from 'components/_UI/ButtonSelect'
import { ButtonSelectItem, SelectContainer, SelectWrapper } from 'components/_UI/SelectsContent'
import Text from 'components/_UI/Text'
import { useEventFilter } from 'context/events/EventFilter'
import React, { useEffect } from 'react'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors'
import eventTypes from 'theme/eventTypes'

let types = [];

export default function TypesSelects({refresh}) {
    const { eventFilter, setEventFilter } = useEventFilter();

    useEffect(() => {
        if (refresh) {
            types = []
        }
    }, [refresh])


    function removeObjectWithId(arr, id) {
        const objWithIndex = arr.findIndex(obj => obj.id === id)

        if (objWithIndex > -1) {
            arr.splice(objWithIndex, 1)
        }

        return arr
    }

    function typesFilter(active, item) {
        const typesObject = {
            active: active === 'ACTIVE' || false,
            name: item.name,
            id: item.id
        }

        if (active === 'INATIVE') {
            const newArray = removeObjectWithId(types, typesObject.id)

            setEventFilter({ ...eventFilter, types: newArray })

            return;
        }

        types.push(typesObject)
        setEventFilter({ ...eventFilter, types })
    }

    return (
        <Column marginTop='18px'>
            <Text size='small' type='bold' marginLeft='6px'> Tipo de evento</Text>
            <Text size='small' color={colors.night}>Escolha os tipos de evento que deseja buscar.</Text>
            <SelectContainer>
                {
                    Object.values(eventTypes).map(el => (
                        <SelectWrapper key={el.id}>
                            <ButtonSelectItem>
                                <ButtonSelect
                                    data={el}
                                    id={`select_type_${el.id === 1 ? 'free' : 'paid'}`}
                                    size={'small'}
                                    onToggle={(state) => typesFilter(state, el)}
                                >
                                    {el.label}
                                </ButtonSelect>
                            </ButtonSelectItem>
                        </SelectWrapper>
                    ))
                }
            </SelectContainer>
        </Column>
    )
}
